import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezoneAbbr'
})
export class TimezoneAbbrPipe implements PipeTransform {
  transform(): string {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Get current abbreviation using moment-timezone
    return moment.tz(new Date(), tz).format('z');
  }
}
